import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineDoubleCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="m1.028 9.297 2.205 1.837m6.983-8.268-4.29 5.82M3.784 9.297l2.007 1.672a.92.92 0 0 0 1.328-.16l5.853-7.943"
    />
  </svg>
);
export default SvgStreamlineDoubleCheck;
